<template>
  <dropdown 
    :placement="placement"
    :offset="offset"
    :force-visibility="forceVisibility"
    :popper-min-width-size="popperMinWidthSize"
    :title="title"
    class="more-button-dropdown"
    @open="onOpen"
    @close="onClose"
  >
    <div 
      class="more-button-dropdown__button" 
      @mouseover="onMouseOver"
      @mouseleave="onMouseLeave">
      <i :class="iconClasses" class="ddi" />
    </div>
    <template #content>
      <div>
        <slot name="options-list" />
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'MoreButtonDropdown',

  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
    /* [skidding, distance] in px, as for the dropdown */
    offset: {
      type: Array as unknown as PropType<[number, number]>,
      default: undefined,
    },
    title: {
      type: String,
      default: 'More options',
    },
    forceVisibility: {
      type: Boolean,
      default: false,
    },
    popperMinWidthSize: {
      type: String,
      default: 'medium',
    },
    verticalEllipsis: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      iconClasses: ['ddi-ellipsis'],
      isOpened: false,
      isRolledOver: false,
    }
  },

  watch: {
    verticalEllipsis: {
      immediate: true,
      handler(val) {
        if (val) {
          this.iconClasses.push('rotate-90')
        }
      },
    },
    forceVisibility(val: boolean) {
      if (val) {
        this.onOpen()
      } else {
        this.onClose()
      }
    },
  },

  methods: {
    updateIconClasses() {
      this.iconClasses = []

      if (this.verticalEllipsis) {
        this.iconClasses.push('rotate-90')
      }
      if (this.isOpened) {
        this.iconClasses.push('dropdown-opened')
        this.iconClasses.push('ddi-ellipsis-filled')
      } else {
        this.iconClasses.push('ddi-ellipsis')

        if (this.isRolledOver) {
          this.iconClasses.push('darkened')
        }
      }
    },
    onOpen() {
      this.isOpened = true
      this.updateIconClasses()
    },
    onClose() {
      this.isOpened = false
      this.updateIconClasses()
    },
    onMouseOver() {
      this.isRolledOver = true
      this.updateIconClasses()
    },
    onMouseLeave() {
      this.isRolledOver = false
      this.updateIconClasses()
    },
  },
})
</script>

<style lang="scss">
.more-button-dropdown {
  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    font-weight: 500;
    font-size: 18px;
    cursor: pointer;

    .ddi-ellipsis {
      color: var(--color-text-third);
    }

    .darkened {
      color: var(--color-text-secondary);
    }

    .dropdown-opened {
      color: $color--blue;
    }
  }
}
</style>
